<template>
	<MoleculeDialogBottom
		:is-open="isCookieDialogOpen"
		:is-closable="false"
		data-nosnippet="data-nosnippet"
	>
		<LazyOrganismFormCookieConsent v-if="isCookieDialogOpen" />
	</MoleculeDialogBottom>
</template>

<script lang="ts" setup>
const {
	isCookieDialogOpen,
} = useConsent();
</script>
